<template>
  <div class="SortPage">
    <AudioTitleComponent></AudioTitleComponent>
    <el-form ref="form" :model="formData" label-width="80px">
      <el-form-item label="选项1">
        <el-input v-model="formData.item[0]"></el-input>
      </el-form-item>
      <el-form-item label="选项2">
        <el-input v-model="formData.item[1]"></el-input>
      </el-form-item>
      <el-form-item label="选项3">
        <el-input v-model="formData.item[2]"></el-input>
      </el-form-item>
      <el-form-item label="选项4">
        <el-input v-model="formData.item[3]"></el-input>
      </el-form-item>
      <el-form-item label="选项5">
        <el-input v-model="formData.item[4]"></el-input>
      </el-form-item>
      <el-form-item label="正确顺序">
        <el-input></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addLessonContentMixins } from "@/pages/MyOutLine/addLessonContentMixins";
import AudioTitleComponent from "@/pages/MyOutLine/AudioTitleComponent.vue";

export default {
  name: "SortPage",
  components: { AudioTitleComponent },
  mixins: [addLessonContentMixins],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.SortPage {
  //::v-deep .el-form-item{
  //  margin-bottom: 0px !important;
  //}
}
</style>
